import * as types from "./actionTypes";

export function userChangeLanguage(language) {
  return {
    type: types.CHANGE_LANGUAGE,
    payload: language,
  };
}
